import React, { Component } from 'react';
import {
  Content,
  Details,
  Line,
  Title,
  Value,
  Wrapper,
} from './styles';

class DetailsTable extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { volumeDetailsData, serial } = this.props;

    return (
      <Details>
        <Line>
          <Content>
            <Wrapper>
              <Title>Serial</Title>
              <Value>{serial}</Value>
            </Wrapper>
          </Content>
          <Content>
            <Wrapper>
              <Title>Monitor</Title>
              <Value>{volumeDetailsData.monitor}</Value>
            </Wrapper>
          </Content>
          <Content>
            <Wrapper>
              <Title>Descrição</Title>
              <Value>{volumeDetailsData.description}</Value>
            </Wrapper>
          </Content>
          <Content>
            <Wrapper>
              <Title>Temp. Mín</Title>
              <Value>{volumeDetailsData.minimumTemperature}°C</Value>
            </Wrapper>
          </Content>
          <Content>
            <Wrapper>
              <Title>Temp. Méd</Title>
              <Value>{volumeDetailsData.averageTemperature}°C</Value>
            </Wrapper>
          </Content>
          <Content>
            <Wrapper>
              <Title>Temp. Máx</Title>
              <Value>{volumeDetailsData.maximumTemperature}°C</Value>
            </Wrapper>
          </Content>
        </Line>
      </Details>
    );
  }
}

export default DetailsTable;
